const parseBasePath = (prefix, pathName) =>
  pathName.slice(pathName.indexOf(prefix)).replace(prefix, "")

export const removeProtocol = (pathName) => (pathName || "").replace(/^(http|https):\/\//g, "");
export const getHostName    = (pathName)=> (pathName || "").match(/^(?:\/\/|[^/]+)*/)[0];

export default parseBasePath
